// Basic
import PropTypes from 'prop-types';
// Store & actions
import useSessionStore from '@/app/store/session';
import actionsPlans from '../../api/actionsPlans';
// Components
import Dropdown from '@/common-utils/components/renders/dropdown/Dropdown';
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import ICONS from '@/common-utils/enums/icons';
import Permissions from '@/app/permissions/Permissions';
import { useToast } from '@/common-utils/hooks/use-toast';
// Lang
import { nsPlan } from '@/app/i18n/namespaces';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
/**
 * @param root0
 * @param root0.parentPlan
 * @param root0.organizationId
 * @param root0.setLaunchRefetch
 * @returns {JSX} DropdownParentPlansActionsRow
 */
function DropdownParentPlansActionsRow({ parentPlan, organizationId, setLaunchRefetch }) {
    // Constants
    const { uuid: planId, label, ownerOrganization } = parentPlan;

    // Toast
    const { toast } = useToast();

    // Store
    const permissions = useSessionStore(s => s.session.permissions);

    //API calls
    const onSuccess = () => {
        setLaunchRefetch(true);
        toast({
            description: <Entity namespace={nsPlan} entity='toast.success.delete_allowed_client' />,
            variant: 'success'
        });
    };
    const onError = (error) => {
        const errorCode = error.response?.data?.errorCode ?? error.code;
        const addClientErrorCode = errorCode === 'SUBSCRIPTION_PLAN_IS_PARENT_OFFER' ? 'SUBSCRIPTION_PLAN_IS_PARENT_OFFER' : 'UNKNOWN_ERROR';
        toast({
            description: <Entity namespace={nsPlan} entity={`toast.error.${addClientErrorCode}`} />,
            variant: 'danger'
        });
    };
    const deleteAllowedClient = actionsPlans.deleteAllowedClient(onSuccess, onError);

    return (
        <Dropdown
            triggerValues={{ variant: 'ghostNoBorder', icon: ICONS.MORE }}
            actions={[
                {
                    icon: ICONS.CLOSE,
                    entity: 'actions.row.parent_plans.delete',
                    data: { labelName: label },
                    variant: 'danger',
                    namespace: nsPlan,
                    onClick: () => {
                        deleteAllowedClient.mutate({
                            planId: planId,
                            organizationId: ownerOrganization,
                            allowedClientId: organizationId
                        });
                    },
                    visible: true,
                    disabled: !hasRequiredPermissions({
                        permissions: permissions,
                        requiredPermissions: [Permissions.SUBSCRIPTION_PLAN_DELETE_CLIENT.name]
                    }),
                    tooltipForbidden: 'title.permissions.access_denied'
                }
            ]} />
    );
}

DropdownParentPlansActionsRow.propTypes = {
    parentPlan: PropTypes.object.isRequired,
    organizationId: PropTypes.string.isRequired,
    setLaunchRefetch: PropTypes.func
};

export default DropdownParentPlansActionsRow;